import { gql } from '@apollo/client'

const UPDATE_DISH_TYPE_NOTES_MUTATION = gql`
  mutation updateDishTypeNotes($id: ID!, $data: DishTypeNotesInput!) {
    updateDishTypeNotes(id: $id, data: $data) {
      id
      updatedAt
      updatedBy {
        id
        name
      }
      notes
    }
  }
`

export default UPDATE_DISH_TYPE_NOTES_MUTATION
